/// <amd-module name="Repos/Views/ProjectPolicies/PolicyTypeNames" />
import * as Resources from "Repos/Views/ProjectPolicies/Resources";

export const policyTypeNameMap: { [key: string]: string } = {
    "fa4e907d-c16b-4a4c-9dfa-4906e5d171dd": Resources.PolicyType_ApproverCount,
    "0609b952-1397-4640-95ec-e00a01b2c241": Resources.PolicyType_Build,
    "c6a1889d-b943-4856-b76f-9e46bb6b0df2": Resources.PolicyType_CommentRequirements,
    "fa4e907d-c16b-4a4c-9dfa-4916e5d171ab": Resources.PolicyType_MergeStrategy,
    "fd2167ab-b0be-447a-8ec8-39368250530e": Resources.PolicyType_RequiredReviewers,
    "cbdc66da-9728-4af8-aada-9a5a32e4a226": Resources.PolicyType_Status,
    "40e92b44-2fe1-4dd6-b3d8-74a9c21d0c6e": Resources.PolicyType_WorkItemLinking,
};

export function findPolicyTypeName(policyTypeId: string): string {
    return policyTypeNameMap[policyTypeId] || Resources.PolicyType_Unknown;
}
